import { getAgentsPage } from "./agents";
import { getIntegrationPage } from "./integration";
import { getN8nPage } from "./n8n";
import { getRagPage } from "./rag";
import { getResearchPage } from "./research";
import {
  SERVICE_PAGE_SLUGS,
  type ServicePage,
  type ServicePageSlug,
} from "./types";

/**
 * Builders rather than data: every string is a message call, so a page has to
 * be built inside the request that knows its locale.
 */
const BUILDERS: Record<ServicePageSlug, () => ServicePage> = {
  "ai-agent-development": getAgentsPage,
  "ai-integration": getIntegrationPage,
  "ai-research-agents": getResearchPage,
  "n8n-automation": getN8nPage,
  "rag-development": getRagPage,
};

/**
 * Narrows an untrusted URL segment. `includes` on the tuple rather than an
 * object lookup, so inherited keys such as `constructor` never match.
 */
export function isServicePageSlug(slug: string): slug is ServicePageSlug {
  return (SERVICE_PAGE_SLUGS as readonly string[]).includes(slug);
}

export function getServicePage(slug: ServicePageSlug): ServicePage {
  return BUILDERS[slug]();
}

/** Every page, in the order the site lists them. */
export function getServicePages(): ServicePage[] {
  return SERVICE_PAGE_SLUGS.map((slug) => BUILDERS[slug]());
}
